import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'react-bootstrap'
import { API_URL, TIPI_BILANCIA } from '../../constants'
import { useState } from 'react'
import SelectAutoCompleteFilter from '../../components/SelectAutocompleteFilter'
import { UseQueryResult } from '@tanstack/react-query'
import { Cliente } from '../../types'

export default function ModalFiltersBilancia({
  isOpen,
  toggle,
  setFilters,
  filters,
  cliente = null,
}: {
  isOpen: boolean
  toggle: () => void
  setFilters: any
  filters: any
  cliente?: UseQueryResult<Cliente, Error> | null
}) {
  const [stateBilanciaFilters, setStateBilanciaFilters] = useState({
    tipo_bilancia: filters.tipo_bilancia,
    cliente: filters.cliente,
    rapporto_taratura: filters.rapporto_taratura,
    verif_periodica: filters.verif_periodica,
    sede: filters.sede,
    fuori_uso: filters.fuori_uso,
    dismessa: filters.dismessa,
    data_scadenza_periodica__gte: filters.data_scadenza_periodica__gte,
    data_scadenza_periodica__lte: filters.data_scadenza_periodica__lte,
    data_scadenza_taratura__gte: filters.data_scadenza_taratura__gte,
    data_scadenza_taratura__lte: filters.data_scadenza_taratura__lte,
    con_richiesta_periodica: filters.con_richiesta_periodica,
    data_richiesta_periodica__gte: filters.data_richiesta_periodica__gte,
    data_richiesta_periodica__lte: filters.data_richiesta_periodica__lte,
    data_intervento_periodica_aperto__isnull:
      filters.data_intervento_periodica_aperto__isnull,
    data_intervento_periodica_aperto__gte:
      filters.data_intervento_periodica_aperto__gte,
    data_intervento_periodica_aperto__lte:
      filters.data_intervento_periodica_aperto__lte,
    data_intervento_taratura_aperto__gte:
      filters.data_intervento_taratura_aperto__gte,
    data_intervento_taratura_aperto__lte:
      filters.data_intervento_taratura_aperto__lte,
    data_intervento_taratura_aperto__isnull:
      filters.data_intervento_taratura_aperto__isnull,
    autoprodotta: filters.autoprodotta,
  })
  return (
    <Modal show={isOpen} onHide={toggle} centered size="xl">
      <ModalHeader closeButton>
        <h5>Filtri personalizzati</h5>
      </ModalHeader>
      <ModalBody
        style={{
          maxHeight: 'calc(100vh - 200px)',
          overflowY: 'auto',
        }}
      >
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label className="label-m text-body-secondary">
                Tipo bilancia
              </label>
              <select
                className="form-select"
                value={stateBilanciaFilters.tipo_bilancia}
                onChange={(e) =>
                  setStateBilanciaFilters({
                    ...stateBilanciaFilters,
                    tipo_bilancia: e.target.value,
                  })
                }
              >
                <option value="">Tutte le bilance</option>
                {TIPI_BILANCIA.map((tipo) => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </option>
                ))}
              </select>
            </div>

            {!cliente && (
              <div className="form-group mt-2">
                <label className="label-m text-body-secondary">Cliente</label>
                <SelectAutoCompleteFilter
                  menuPortalTarget={false}
                  value={stateBilanciaFilters.cliente}
                  onChange={(value: any) => {
                    if (!value) {
                      setStateBilanciaFilters({
                        ...stateBilanciaFilters,
                        cliente: '',
                        sede: '',
                      })
                    } else {
                      setStateBilanciaFilters({
                        ...stateBilanciaFilters,
                        cliente: value.value,
                      })
                    }
                  }}
                  url={`${API_URL}/bilance/cliente/options`}
                  isMulti={false}
                />
              </div>
            )}
            <div className="form-group mt-2">
              <label className="label-m text-body-secondary">Sede</label>
              <SelectAutoCompleteFilter
                menuPortalTarget={false}
                value={stateBilanciaFilters.sede}
                isDisabled={!stateBilanciaFilters.cliente && !cliente}
                params={{
                  cliente: stateBilanciaFilters.cliente || cliente?.data?.id,
                }}
                onChange={(value: any) => {
                  if (!value) {
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      sede: '',
                    })
                  } else {
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      sede: value.value,
                    })
                  }
                }}
                url={`${API_URL}/bilance/sede/options`}
                isMulti={false}
              />
            </div>
            <div className="form-group mt-2">
              <label className="label-m text-body-secondary">Fuori uso</label>
              <select
                className="form-select"
                value={stateBilanciaFilters.fuori_uso}
                onChange={(e) =>
                  setStateBilanciaFilters({
                    ...stateBilanciaFilters,
                    fuori_uso: e.target.value,
                  })
                }
              >
                <option value="">Tutte</option>
                <option value="true">Si</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="form-group mt-2">
              <label className="label-m text-body-secondary">Dismessa</label>
              <select
                className="form-select"
                value={stateBilanciaFilters.dismessa}
                onChange={(e) =>
                  setStateBilanciaFilters({
                    ...stateBilanciaFilters,
                    dismessa: e.target.value,
                  })
                }
              >
                <option value="">Tutte</option>
                <option value="true">Si</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="form-group mt-2">
              <label className="label-m text-body-secondary">Autoprodotta</label>
              <select
                className="form-select"
                value={stateBilanciaFilters.autoprodotta}
                onChange={(e) =>
                  setStateBilanciaFilters({
                    ...stateBilanciaFilters,
                    autoprodotta: e.target.value,
                  })
                }
              >
                <option value="">Tutte</option>
                <option value="true">Si</option>
                <option value="false">No</option>
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="label-m text-body-secondary">
                Tipo intervento
              </label>
              <div className="mt-1">
                <input
                  type="checkbox"
                  className="me-2"
                  checked={stateBilanciaFilters.verif_periodica}
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      verif_periodica: e.target.checked ? 'true' : '',
                    })
                  }
                />{' '}
                Verifica periodica
              </div>
            </div>
            <div className="form-group mt-3">
              <label className="label-m text-body-secondary">SCADENZA</label>
              <div className="p-sm mt-3">Seleziona un periodo</div>
              <div className="mt-2">
                <input
                  type="date"
                  className="form-control"
                  placeholder="Da"
                  value={stateBilanciaFilters.data_scadenza_periodica__gte}
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_scadenza_periodica__gte: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-1">
                <input
                  type="date"
                  className="form-control"
                  placeholder="A"
                  value={stateBilanciaFilters.data_scadenza_periodica__lte}
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_scadenza_periodica__lte: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="form-group mt-3">
              <label className="label-m text-body-secondary">Richiesta</label>
              <div className="mt-1">
                <select
                  className="form-select"
                  value={stateBilanciaFilters.con_richiesta_periodica}
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      con_richiesta_periodica: e.target.value,
                    })
                  }
                >
                  <option value="">Tutte</option>
                  <option value="true">Con richiesta</option>
                  <option value="false">Senza richiesta</option>
                </select>
              </div>
            </div>
            <div className="form-group mt-3">
              <div className="p-sm mt-3">Seleziona un periodo</div>
              <div className="mt-2">
                <input
                  type="date"
                  className="form-control"
                  placeholder="Da"
                  disabled={!stateBilanciaFilters.con_richiesta_periodica}
                  value={stateBilanciaFilters.data_richiesta_periodica__gte}
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_richiesta_periodica__gte: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-1">
                <input
                  type="date"
                  className="form-control"
                  placeholder="A"
                  disabled={!stateBilanciaFilters.con_richiesta_periodica}
                  value={stateBilanciaFilters.data_richiesta_periodica__lte}
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_richiesta_periodica__lte: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="form-group mt-3">
              <label className="label-m text-body-secondary">Programmate</label>
              <div className="mt-1">
                <select
                  className="form-select"
                  value={
                    stateBilanciaFilters.data_intervento_periodica_aperto__isnull
                  }
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_intervento_periodica_aperto__isnull: e.target.value,
                    })
                  }
                >
                  <option value="">Tutte</option>
                  <option value="true">Non programmate</option>
                  <option value="false">Programmate</option>
                </select>
              </div>
            </div>
            <div className="form-group mt-3">
              <div className="p-sm mt-3">Seleziona un periodo</div>
              <div className="mt-2">
                <input
                  type="date"
                  className="form-control"
                  placeholder="Da"
                  value={
                    stateBilanciaFilters.data_intervento_periodica_aperto__gte
                  }
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_intervento_periodica_aperto__gte: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-1">
                <input
                  type="date"
                  className="form-control"
                  placeholder="A"
                  value={
                    stateBilanciaFilters.data_intervento_periodica_aperto__lte
                  }
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_intervento_periodica_aperto__lte: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="label-m text-body-secondary"></label>
              <div className="mt-1">
                <input
                  type="checkbox"
                  className="me-2"
                  checked={stateBilanciaFilters.rapporto_taratura === 'true'}
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      rapporto_taratura: e.target.checked ? 'true' : '',
                    })
                  }
                />{' '}
                Rapporto taratura
              </div>
            </div>
            <div className="form-group mt-3">
              <label className="label-m text-body-secondary">SCADENZA</label>
              <div className="p-sm mt-3">Seleziona un periodo</div>
              <div className="mt-2">
                <input
                  type="date"
                  className="form-control"
                  placeholder="Da"
                  value={stateBilanciaFilters.data_scadenza_taratura__gte}
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_scadenza_taratura__gte: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-1">
                <input
                  type="date"
                  className="form-control"
                  placeholder="A"
                  value={stateBilanciaFilters.data_scadenza_taratura__lte}
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_scadenza_taratura__lte: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="form-group mt-3">
              <label className="label-m text-body-secondary">Programmate</label>
              <div className="mt-1">
                <select
                  className="form-select"
                  value={
                    stateBilanciaFilters.data_intervento_taratura_aperto__isnull
                  }
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_intervento_taratura_aperto__isnull: e.target.value,
                    })
                  }
                >
                  <option value="">Tutte</option>
                  <option value="true">Non programmate</option>
                  <option value="false">Programmate</option>
                </select>
              </div>
              <div className="p-sm mt-3">Seleziona un periodo</div>
              <div className="mt-2">
                <input
                  type="date"
                  className="form-control"
                  placeholder="Da"
                  value={
                    stateBilanciaFilters.data_intervento_taratura_aperto__gte
                  }
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_intervento_taratura_aperto__gte: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-1">
                <input
                  type="date"
                  className="form-control"
                  placeholder="A"
                  value={
                    stateBilanciaFilters.data_intervento_taratura_aperto__lte
                  }
                  onChange={(e) =>
                    setStateBilanciaFilters({
                      ...stateBilanciaFilters,
                      data_intervento_taratura_aperto__lte: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            setFilters({ ...filters, ...stateBilanciaFilters })
            toggle()
          }}
          variant="secondary"
          className="text-white"
        >
          Applica filtri
        </Button>
      </ModalFooter>
    </Modal>
  )
}
